(function () {
  if (window.__rootsProductCardsInit) return;
  window.__rootsProductCardsInit = true;

  function init() {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) return;
    document.querySelectorAll('[data-rpc-root]:not(.rpc-js)').forEach(function (root) {
      root.classList.add('rpc-js');
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              root.classList.add('rpc-in');
              io.disconnect();
            }
          });
        },
        { threshold: 0.2 }
      );
      io.observe(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
